
import extend from '@/utils/vuex-extend';
import { table } from '@/vuex-extend';
import { wait } from '@/utils/wait';
import { fetchList } from '@/api/pcm/order';

export default extend(table, {
    namespaced: true,
    state: {
		searchForm: {},
		list: []
    },
    actions: {
        async getList({ state, dispatch }, payload) {
			await wait(dispatch, 'pcm.order.list', async function() {
				const { searchForm } = state;
				await dispatch('getData', {
					caller: fetchList,
					options: {
						...searchForm,
						...payload
					}
				});
            })
		},
		async returnOrder({ dispatch }, id) {
			await returnOrder(id);
			dispatch('getList');
		}
    }
})



// WEBPACK FOOTER //
// ./src/store/modules/pcm/order/list.js